/**
 * Quote creation specific JavaScript functionality
 * ES Module - imported by main.js and exposed on window
 */

// Get language prefix from URL for i18n-aware URL construction
function _getLangPrefix() {
    const match = window.location.pathname.match(/^\/([a-z]{2})\//);
    return match ? `/${match[1]}` : '';
}

function updateSelection(suggestions, index) {
    suggestions.forEach((s, i) => {
        if (i === index) {
            s.classList.add('bg-gray-100');
            s.scrollIntoView({ block: 'nearest' });
        } else {
            s.classList.remove('bg-gray-100');
        }
    });
}

export function initializeCustomerSearch() {
    const searchInput = document.getElementById('customer-search');
    const suggestionsDiv = document.getElementById('customer-suggestions');
    const customerIdInput = document.getElementById('id_customer');

    if (!searchInput || !suggestionsDiv || !customerIdInput) {
        return;
    }

    // Show/hide suggestions
    searchInput.addEventListener('focus', () => {
        if (suggestionsDiv.innerHTML.trim()) {
            suggestionsDiv.classList.remove('hidden');
        }
    });

    // Hide suggestions when clicking outside
    document.addEventListener('click', (e) => {
        if (!e.target.closest('#customer-search') &&
            !e.target.closest('#customer-suggestions')) {
            suggestionsDiv.classList.add('hidden');
        }
    });

    // Keyboard navigation
    let selectedIndex = -1;
    searchInput.addEventListener('keydown', (e) => {
        const suggestions = suggestionsDiv.querySelectorAll('.customer-suggestion');

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            selectedIndex = Math.min(selectedIndex + 1, suggestions.length - 1);
            updateSelection(suggestions, selectedIndex);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            selectedIndex = Math.max(selectedIndex - 1, -1);
            updateSelection(suggestions, selectedIndex);
        } else if (e.key === 'Enter' && selectedIndex >= 0) {
            e.preventDefault();
            suggestions[selectedIndex].click();
        } else if (e.key === 'Escape') {
            suggestionsDiv.classList.add('hidden');
        }
    });

    // Reset selection when new search results come in
    document.body.addEventListener('htmx:afterSwap', (e) => {
        if (e.target === suggestionsDiv) {
            selectedIndex = -1;
        }
    });
}

export function selectCustomer(element) {
    const customerId = element.dataset.customerId;
    const customerName = element.dataset.customerName;

    // Update form fields
    document.getElementById('id_customer').value = customerId;
    document.getElementById('customer-search').value = customerName;

    // Hide suggestions
    document.getElementById('customer-suggestions').classList.add('hidden');

    // Update project dropdown
    const prefix = _getLangPrefix();
    htmx.ajax('GET', `${prefix}/projects/options/?customer_id=${customerId}`, {
        target: '#id_project',
        swap: 'outerHTML'
    });

    // Show selected customer details
    showSelectedCustomer(customerId);
}

function showSelectedCustomer(customerId) {
    const prefix = _getLangPrefix();
    htmx.ajax('GET', `${prefix}/customers/${customerId}/summary/`, {
        target: '#selected-customer',
        swap: 'innerHTML'
    }).then(() => {
        document.getElementById('selected-customer').classList.remove('hidden');
    });
}

export function initializeProjectSelection() {
    // Project selection is handled via HTMX and the template
    // This function is for any additional initialization if needed
}
